export default __webpack_public_path__ + "static/media/hero-m.0331bd21.jpg";